"use strict";
import Api from "../api/api";
export default (document) => {
  const overrideTypes = Api.Account.current().settings.allowed_as_pod_override_document_types || [];
  if (overrideTypes.length > 0)
    return document && overrideTypes.indexOf(document.type) >= 0;
  const invalidTypes = [
    "invoice",
    "carrierInvoice",
    "factorInvoice",
    "rateConfirmation",
    "contract",
    "noticeOfRelease",
    "noticeOfAssignment",
    "insuranceCertificate",
    "fundingForm",
    "other"
  ];
  return document && invalidTypes.indexOf(document.type) < 0;
};
